import { render, staticRenderFns } from "./SpecializationInfoTalentFind.vue?vue&type=template&id=0b093210"
import script from "./SpecializationInfoTalentFind.vue?vue&type=script&lang=js"
export * from "./SpecializationInfoTalentFind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports